import { Tooltip } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import * as React from "react";

import { Text } from "../../";
import { CheckIcon } from "../../assets/icons";
import { TagMatchType } from "../../domain";
import { RelodeTheme } from "../styles/relodeTheme";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            checkIcon: {
                color: theme.relode.colors.positiveAction.main,
                paddingTop: "6px",
                position: "relative",
                top: "3px",
            },
            statusHistoryContainer: {
                display: "flex",
            },
            statusHistory: {
                marginRight: theme.spacing(2),
                marginTop: theme.spacing(1),
            },
        }),
    { name: "StatusHistory" }
);

interface Props {
    statusHistoryTags: TagMatchType[];
}

export interface StatusHistoryProps extends Props {}

export const StatusHistory = (props: Props) => {
    const classes = useStyles({});
    if (!props.statusHistoryTags || props.statusHistoryTags.length === 0)
        return null;
    return (
        <div className={classes.statusHistoryContainer}>
            {props.statusHistoryTags.map(tag => (
                <Tooltip
                    key={tag.tagId}
                    title="Previous or current statuses achieved by this candidate."
                    placement="right"
                >
                    <Text variant="body1" className={classes.statusHistory}>
                        <CheckIcon className={classes.checkIcon} />{" "}
                        {tag.tagName.toLowerCase()}
                    </Text>
                </Tooltip>
            ))}
        </div>
    );
};
